import { compose } from '@reduxjs/toolkit';
import { fetchPromotionListReducer } from './fetchPromotionList';

export const extraReducers = compose(fetchPromotionListReducer);
export { fetchPromotionList } from './fetchPromotionList';
